import { createSelector } from '@reduxjs/toolkit'

import type { TSimChatDto } from '@homepal/api-contract'

import { ApplicationState } from 'redux/Stores/types'
import { SimChatReducerType } from 'redux/reducers/internal/SimChats'

export const selectInternalSimChats = createSelector(
  [(state: ApplicationState): SimChatReducerType => state.InternalSimChatStore],
  (store) => store
)

export const selectInternalSimChat = (
  state: ApplicationState,
  id: string | null
): TSimChatDto | null =>
  id ? state.InternalSimChatStore.chats[id] ?? null : null

export const selectInternalSimChatFetching = (
  state: ApplicationState,
  id: string | null
): boolean =>
  id ? state.InternalSimChatStore.fetchingChatIds.includes(id) : false

/**
 * UI-facing aliases for the wire types, so components import these rather
 * than the contract's exact export names.
 */
export type {
  TSimChatSummaryDto as SimChatSummary,
  TSimChatMessageDto as SimChatMessage,
  TSimChatDto as SimChat
} from '@homepal/api-contract'
